import { downloadProjectBulkTemplate, uploadProjectBulkExcel } from './api/projectApi'
import SharedBulkUploadScreen from '../../../components/SharedBulkUploadScreen'

const TEMPLATES = [
  {
    key: 'non_billable',
    icon: 'folder',
    color: '#0EA5E9',
    badge: 'Internal',
    title: 'Non-Billable Projects',
    subtitle: 'Internal, R&D, bench & non-charging work',
    description:
      'Use this template for internal projects, R&D initiatives, bench work, or any project that does not generate client revenue. No billing fields required.',
    columns: ['Project Name', 'Description', 'Company', 'Branch', 'Department', 'Start Date', 'End Date', 'Priority', 'Lead', 'Team', 'Notes'],
    fileName: 'Non_Billable_Project_Upload_Template.xlsx',
    downloadFn: () => downloadProjectBulkTemplate('non_billable'),
  },
  {
    key: 'project_billing',
    icon: 'payments',
    color: '#0EA5E9',
    badge: 'Billable',
    title: 'Project Billing Settings',
    subtitle: 'Fixed Price & Time & Material contracts',
    description:
      'Use this template for client-facing projects billed on a fixed contract or T&M hourly basis. Includes customer, billing type, budget, advance received, and due date fields.',
    columns: ['Project Name', 'Company', 'Billing Type', 'Budget', 'Bill Due Date', 'Advance', 'Received', 'Lead', 'Team'],
    fileName: 'Project_Billing_Upload_Template.xlsx',
    downloadFn: () => downloadProjectBulkTemplate('project_billing'),
  },
  {
    key: 'amc_revenue',
    icon: 'autorenew',
    color: '#0EA5E9',
    badge: 'Recurring',
    title: 'AMC Revenue Settings',
    subtitle: 'Monthly, Quarterly, Half-Yearly & Yearly contracts',
    description:
      'Use this template for recurring Annual Maintenance Contracts. Specify per-cycle AMC amount, frequency, billing timing and initial cycle dates — subsequent cycles are auto-calculated.',
    columns: ['Project Name', 'AMC Amount (per cycle)', 'Frequency', 'Billing Timing', 'AMC Start Date', 'AMC End Date', 'Currency'],
    fileName: 'AMC_Revenue_Upload_Template.xlsx',
    downloadFn: () => downloadProjectBulkTemplate('amc_revenue'),
  },
]

export default function ProjectBulkUploadScreen() {
  return (
    <SharedBulkUploadScreen
      eyebrow="Enterprise Portfolio"
      title="Bulk Project Upload"
      subtitle="Import multiple projects at once using one of the three standardised Excel templates."
      returnUrl="/nerve/project/list"
      templates={TEMPLATES}
      uploadFn={uploadProjectBulkExcel}
      entityLabelSingular="project"
      entityLabelPlural="projects"
    />
  )
}
